import { useAuth } from '../AuthContext';
import ThemeToggle from './ThemeToggle';

interface AppHeaderProps {
  children: React.ReactNode;
  actions?: React.ReactNode;
  style?: React.CSSProperties;
}

export default function AppHeader({ children, actions, style }: AppHeaderProps) {
  const { user, logout } = useAuth();

  return (
    <header className="header" style={style}>
      {children}
      <div className="header-user">
        <span className="header-user-email">{user?.email}</span>
        {actions}
        <ThemeToggle />
        <button onClick={logout} className="btn btn-ghost btn-small">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <polyline points="16,17 21,12 16,7" />
            <line x1="21" y1="12" x2="9" y2="12" />
          </svg>
          Logout
        </button>
      </div>
    </header>
  );
}
